/**
 * The /v2/communication/{id}/messages endpoint returns
 * `Result<MessagesResult>` where `MessagesResult = { messages: ListResult, list_users }`.
 * Different code paths in the rest of the saga have historically read the
 * response one or two unwrap-levels up. This helper accepts every shape we've
 * seen in production and always returns a flat message array.
 */
export function extractMessagesPayload(result: any): { messages: any[]; atStart?: boolean; atEnd?: boolean } {
  if (!result) return { messages: [] };
  // Shape A: { success, data: { messages: { data: [...], atStart, atEnd } }, ... }  (nested MessagesResult)
  const nested = result?.data?.messages;
  if (nested && Array.isArray(nested.data)) {
    return { messages: nested.data, atStart: nested.atStart, atEnd: nested.atEnd };
  }
  // Shape B: { success, data: { data: [...], atStart, atEnd }, ... }  (already-unwrapped MessagesResult)
  if (result?.data && Array.isArray(result.data.data)) {
    return { messages: result.data.data, atStart: result.data.atStart, atEnd: result.data.atEnd };
  }
  // Shape C: { success, data: [...], atStart, atEnd }  (flat ListResult)
  if (Array.isArray(result?.data)) {
    return { messages: result.data, atStart: result.atStart, atEnd: result.atEnd };
  }
  return { messages: [], atStart: result?.atStart, atEnd: result?.atEnd };
}
